export default __webpack_public_path__ + "static/media/eDNA collaborative.ebcfc302.png";